import { DateTime } from 'luxon'

import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { useErrorStore } from 'Common/store/useErrorStore'

import NewDialog from '../dialog/NewDialog'

export function ErrorListDialog(props: Readonly<{ onClose: () => void }>) {
    const { onClose } = props
    const errors = useErrorStore((s) => s.errors)

    return (
        <NewDialog onClose={onClose} title="Session errors">
            <Grid size={12}>
                {errors.length === 0 ? (
                    <Typography>No errors logged.</Typography>
                ) : (
                    <List>
                        {errors.map((error) => (
                            <ListItem key={error.status + error.time}>
                                <Stack>
                                    <ListItemText
                                        primary={error.message}
                                        secondary={DateTime.fromISO(error.time)
                                            .toLocal()
                                            .toLocaleString(DateTime.DATETIME_MED)}
                                    />
                                </Stack>
                            </ListItem>
                        ))}
                    </List>
                )}
            </Grid>
        </NewDialog>
    )
}
